import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalstorageService {
  private prefix = 'jio-loyalty';
  constructor() {}

  addItem(key: string, value: string | null) {
    localStorage.setItem(`${this.prefix}.${key}`, JSON.stringify(value));
  }

  removeItem(key: string) {
    localStorage.removeItem(`${this.prefix}.${key}`);
  }

  getItem(key: string): unknown {
    const item = localStorage.getItem(`${this.prefix}.${key}`);
    return item ? JSON.parse(item) : null;
  }

  clear() {
    localStorage.clear();
  }
}
